import { useQuery } from "@apollo/client";
import { USER_DROPDOWNS_WITH_DEPT } from "../../Queries";

export default (props) => {
  const { data, refetch, loading, error } = useQuery(USER_DROPDOWNS_WITH_DEPT, {
    ...props,
  });
  return { data: data?.userDropwownsWithDept, loading, refetch, error };
};
